module.exports = __webpack_public_path__ + "img/img_avatar.a4bcdcf2.png";